/* global axios */
import ApiClient from '../ApiClient';

class KanbanTasksAPI extends ApiClient {
  constructor() {
    super('kanban/boards', { accountScoped: true });
  }

  tasksUrl(boardId) {
    return `${this.url}/${boardId}/tasks`;
  }

  list(boardId) {
    return axios.get(this.tasksUrl(boardId));
  }

  show(boardId, taskId) {
    return axios.get(`${this.tasksUrl(boardId)}/${taskId}`);
  }

  create(boardId, task) {
    return axios.post(this.tasksUrl(boardId), { task });
  }

  update(boardId, taskId, task) {
    return axios.patch(`${this.tasksUrl(boardId)}/${taskId}`, { task });
  }

  destroy(boardId, taskId) {
    return axios.delete(`${this.tasksUrl(boardId)}/${taskId}`);
  }

  move(boardId, taskId, boardStepId) {
    return axios.patch(`${this.tasksUrl(boardId)}/${taskId}/move`, {
      board_step_id: boardStepId,
    });
  }
}

export default new KanbanTasksAPI();
